import { render, staticRenderFns } from "./CompanyOfficialDash.vue?vue&type=template&id=3f003098&scoped=true"
import script from "./CompanyOfficialDash.vue?vue&type=script&lang=js"
export * from "./CompanyOfficialDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f003098",
  null
  
)

export default component.exports